import React from 'react';
import cx from 'classnames';
import styles from './index.scss';

interface ContentProps {
  className?: string;
}

export const Content = ({ className }: ContentProps) => {
  return (
    <div className={cx(styles.Content, className)}>
      <div />
      <div />
      <div />
    </div>
  );
};
